document.addEventListener('DOMContentLoaded', function() {
  // Login Modal Logic
  const loginModal = document.getElementById('LoginModal');
  const openLoginBtn = document.getElementById('OpenLoginModal');
  const closeLoginBtn = document.getElementById('CloseLoginModal');
  const switchAuthBtn = document.getElementById('SwitchAuthMode');
  const loginView = document.getElementById('LoginView');
  const registerView = document.getElementById('RegisterView');
  const switchText = document.getElementById('SwitchText');

  if (openLoginBtn) {
    openLoginBtn.addEventListener('click', () => {
      loginModal.classList.remove('hidden');
      loginModal.classList.add('flex');
    });
  }

  if (closeLoginBtn) {
    closeLoginBtn.addEventListener('click', () => {
      loginModal.classList.add('hidden');
      loginModal.classList.remove('flex');
    });
  }

  if (switchAuthBtn) {
    switchAuthBtn.addEventListener('click', () => {
      if (loginView.classList.contains('hidden')) {
        loginView.classList.remove('hidden');
        registerView.classList.add('hidden');
        switchText.textContent = 'Non sei ancora registrato?';
        switchAuthBtn.textContent = 'Registrati Ora';
      } else {
        loginView.classList.add('hidden');
        registerView.classList.remove('hidden');
        switchText.textContent = 'Hai già un account?';
        switchAuthBtn.textContent = 'Vai al Login';
      }
    });
  }
  // Mobile Menu Logic
  if (!window.mobileMenuInitialized) {
    window.mobileMenuInitialized = true;
    
    document.addEventListener('click', (e) => {
      const toggle = document.getElementById('MobileMenuToggle');
      const menu = document.getElementById('MobileMenu');
      if (!toggle || !menu) return;

      const isToggleClick = toggle.contains(e.target) || e.target === toggle;

      if (isToggleClick) {
        e.preventDefault();
        menu.classList.toggle('hidden');
      }
    });
  }
});
